export enum PreferenceCategory {
  ShirtsFinish = 0,      // id_pms: 3,  control: '0'
  ReusablePackaging = 1, // id_pms: 4,  control: '1'
  Garmentsfolded = 2,    // id_pms: 10, control: '2'
  Debobbling = 3,        // id_pms: 5,  control: '3'
  KnitwearFolding = 4,   // id_pms: 11, control: '5' (skips 4=MinorRepairs)
}

export enum PreferenceCategoryStore {
  ShirtsFinish = 0,
  Debobbling = 3,
  ReusablePackaging = 1,
  Garmentsfolded = 2,
  // MinorRepaires = 4,
  KnitwearFolding = 4,
}

export enum PmsPreferenceCategory {
  Crease = 0,
  Debobbling = 2,
  Folded = 1,
  Garmentsfolded = 10,
  //MinorRepaires = 3,

}


export enum PmsIdPreference {
  ShirtsFinish = 3,
  Debobbling = 5,
  ReusablePackaging = 4,
  Garmentsfolded = 10,
  //MinorRepaires = 1
  KnitwearFolding = 11,
}

export enum PmsIdPreferenceStore {
  ShirtsFinish = 3,
  Debobbling = 5,
  ReusablePackaging = 4,
  Garmentsfolded = 10,
  MinorRepaires = 1,
  KnitwearFolding = 11,
}
export enum PmsTitrePreference {
  ShirtsFinish = 'Shirts Premium Finish',
  Debobbling = 'Debobbling',
  ReusablePackaging = 'Shirts folded',
  Garmentsfolded = "Garments folded",
 // MinorRepaires = 'Proceed with minor repairs'
  KnitwearFolding = 'Knitwear Folding',
}
export enum PmsTitrePreferenceStore {
  ShirtsFinish = 'Shirts Premium Finish',
  Debobbling = 'Debobbling',
  ReusablePackaging =  'Shirts folded',
  MinorRepaires = 'Proceed with minor repairs',
  Garmentsfolded = "Garments folded",
  KnitwearFolding = 'Knitwear Folding',
}
